// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    domainUrl: 'api.uat.responsiblereturns.com.au',
    apiUrl: 'https://api.uat.responsiblereturns.com.au/api/',
    imgUrl: 'https://api.uat.responsiblereturns.com.au/img/',
    pdfUrl: 'https://api.uat.responsiblereturns.com.au/storage/pdfs/',
    attachmentsUrl:
        'https://api.uat.responsiblereturns.com.au/storage/attachments/',
    buildConfig: 'uat',
    frontUrl: 'https://uat.responsiblereturns.com.au/',

    sentry: {
        dsn: "https://a402f3a2e19f6c614da752c080f7ee4b@o4509727744458752.ingest.us.sentry.io/4509794389655552",
        environment: "uat"
    }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
